// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/transportation/reports/oil.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { OffsetDateTime } from "../../../common/date_time/date_time";
import { EmptyRequest } from "../../../common/messages/messages";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "services.transportation.reports";

export interface OilDeliveryNote {
  fileId: string;
  bdnNumber: string;
  vesselName: string;
  vesselImo: string;
  date: OffsetDateTime | undefined;
  product: string;
  quantity: number;
  priorRob?: number | undefined;
  isDeleted?: boolean | undefined;
  supplierOrganisationId: string;
  locationOrganisationId: string;
}

export interface GetOilDeliveryNotesRequest {
  vesselImo: string;
}

export interface GetOilDeliveryNotesResponse {
  oils: OilDeliveryNote[];
}

export interface GetOilDeliveryNoteRequest {
  vesselImo: string;
  odnNumber: string;
  product: string;
  timestamp: string | undefined;
}

export interface OilDeliveryNoteResponse {
  data: OilDeliveryNote | undefined;
  version: number;
}

export interface UpdateOilDeliveryNoteRequest {
  data: OilDeliveryNote | undefined;
  expectedVersion: number;
}

function createBaseOilDeliveryNote(): OilDeliveryNote {
  return {
    fileId: "",
    bdnNumber: "",
    vesselName: "",
    vesselImo: "",
    date: undefined,
    product: "",
    quantity: 0,
    priorRob: undefined,
    isDeleted: undefined,
    supplierOrganisationId: "",
    locationOrganisationId: "",
  };
}

export const OilDeliveryNote: MessageFns<OilDeliveryNote> = {
  encode(message: OilDeliveryNote, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    if (message.bdnNumber !== "") {
      writer.uint32(18).string(message.bdnNumber);
    }
    if (message.vesselName !== "") {
      writer.uint32(26).string(message.vesselName);
    }
    if (message.vesselImo !== "") {
      writer.uint32(34).string(message.vesselImo);
    }
    if (message.date !== undefined) {
      OffsetDateTime.encode(message.date, writer.uint32(42).fork()).join();
    }
    if (message.product !== "") {
      writer.uint32(50).string(message.product);
    }
    if (message.quantity !== 0) {
      writer.uint32(57).double(message.quantity);
    }
    if (message.priorRob !== undefined) {
      writer.uint32(65).double(message.priorRob);
    }
    if (message.isDeleted !== undefined) {
      writer.uint32(72).bool(message.isDeleted);
    }
    if (message.supplierOrganisationId !== "") {
      writer.uint32(82).string(message.supplierOrganisationId);
    }
    if (message.locationOrganisationId !== "") {
      writer.uint32(90).string(message.locationOrganisationId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OilDeliveryNote {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOilDeliveryNote();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.bdnNumber = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.date = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.quantity = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.priorRob = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isDeleted = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.supplierOrganisationId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.locationOrganisationId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OilDeliveryNote {
    return {
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
      bdnNumber: isSet(object.bdnNumber)
        ? globalThis.String(object.bdnNumber)
        : isSet(object.bdn_number)
        ? globalThis.String(object.bdn_number)
        : "",
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : "",
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      date: isSet(object.date) ? OffsetDateTime.fromJSON(object.date) : undefined,
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      priorRob: isSet(object.priorRob)
        ? globalThis.Number(object.priorRob)
        : isSet(object.prior_rob)
        ? globalThis.Number(object.prior_rob)
        : undefined,
      isDeleted: isSet(object.isDeleted)
        ? globalThis.Boolean(object.isDeleted)
        : isSet(object.is_deleted)
        ? globalThis.Boolean(object.is_deleted)
        : undefined,
      supplierOrganisationId: isSet(object.supplierOrganisationId)
        ? globalThis.String(object.supplierOrganisationId)
        : isSet(object.supplier_organisationId)
        ? globalThis.String(object.supplier_organisationId)
        : "",
      locationOrganisationId: isSet(object.locationOrganisationId)
        ? globalThis.String(object.locationOrganisationId)
        : isSet(object.location_organisationId)
        ? globalThis.String(object.location_organisationId)
        : "",
    };
  },

  toJSON(message: OilDeliveryNote): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.bdnNumber !== "") {
      obj.bdnNumber = message.bdnNumber;
    }
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.date !== undefined) {
      obj.date = OffsetDateTime.toJSON(message.date);
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.quantity !== 0) {
      obj.quantity = message.quantity;
    }
    if (message.priorRob !== undefined) {
      obj.priorRob = message.priorRob;
    }
    if (message.isDeleted !== undefined) {
      obj.isDeleted = message.isDeleted;
    }
    if (message.supplierOrganisationId !== "") {
      obj.supplierOrganisationId = message.supplierOrganisationId;
    }
    if (message.locationOrganisationId !== "") {
      obj.locationOrganisationId = message.locationOrganisationId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OilDeliveryNote>, I>>(base?: I): OilDeliveryNote {
    return OilDeliveryNote.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OilDeliveryNote>, I>>(object: I): OilDeliveryNote {
    const message = createBaseOilDeliveryNote();
    message.fileId = object.fileId ?? "";
    message.bdnNumber = object.bdnNumber ?? "";
    message.vesselName = object.vesselName ?? "";
    message.vesselImo = object.vesselImo ?? "";
    message.date = (object.date !== undefined && object.date !== null)
      ? OffsetDateTime.fromPartial(object.date)
      : undefined;
    message.product = object.product ?? "";
    message.quantity = object.quantity ?? 0;
    message.priorRob = object.priorRob ?? undefined;
    message.isDeleted = object.isDeleted ?? undefined;
    message.supplierOrganisationId = object.supplierOrganisationId ?? "";
    message.locationOrganisationId = object.locationOrganisationId ?? "";
    return message;
  },
};

function createBaseGetOilDeliveryNotesRequest(): GetOilDeliveryNotesRequest {
  return { vesselImo: "" };
}

export const GetOilDeliveryNotesRequest: MessageFns<GetOilDeliveryNotesRequest> = {
  encode(message: GetOilDeliveryNotesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOilDeliveryNotesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOilDeliveryNotesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOilDeliveryNotesRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
    };
  },

  toJSON(message: GetOilDeliveryNotesRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOilDeliveryNotesRequest>, I>>(base?: I): GetOilDeliveryNotesRequest {
    return GetOilDeliveryNotesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOilDeliveryNotesRequest>, I>>(object: I): GetOilDeliveryNotesRequest {
    const message = createBaseGetOilDeliveryNotesRequest();
    message.vesselImo = object.vesselImo ?? "";
    return message;
  },
};

function createBaseGetOilDeliveryNotesResponse(): GetOilDeliveryNotesResponse {
  return { oils: [] };
}

export const GetOilDeliveryNotesResponse: MessageFns<GetOilDeliveryNotesResponse> = {
  encode(message: GetOilDeliveryNotesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.oils) {
      OilDeliveryNote.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOilDeliveryNotesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOilDeliveryNotesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.oils.push(OilDeliveryNote.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOilDeliveryNotesResponse {
    return {
      oils: globalThis.Array.isArray(object?.oils) ? object.oils.map((e: any) => OilDeliveryNote.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetOilDeliveryNotesResponse): unknown {
    const obj: any = {};
    if (message.oils?.length) {
      obj.oils = message.oils.map((e) => OilDeliveryNote.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOilDeliveryNotesResponse>, I>>(base?: I): GetOilDeliveryNotesResponse {
    return GetOilDeliveryNotesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOilDeliveryNotesResponse>, I>>(object: I): GetOilDeliveryNotesResponse {
    const message = createBaseGetOilDeliveryNotesResponse();
    message.oils = object.oils?.map((e) => OilDeliveryNote.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetOilDeliveryNoteRequest(): GetOilDeliveryNoteRequest {
  return { vesselImo: "", odnNumber: "", product: "", timestamp: undefined };
}

export const GetOilDeliveryNoteRequest: MessageFns<GetOilDeliveryNoteRequest> = {
  encode(message: GetOilDeliveryNoteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    if (message.odnNumber !== "") {
      writer.uint32(18).string(message.odnNumber);
    }
    if (message.product !== "") {
      writer.uint32(26).string(message.product);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOilDeliveryNoteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOilDeliveryNoteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.odnNumber = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOilDeliveryNoteRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      odnNumber: isSet(object.odnNumber)
        ? globalThis.String(object.odnNumber)
        : isSet(object.odn_number)
        ? globalThis.String(object.odn_number)
        : "",
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : undefined,
    };
  },

  toJSON(message: GetOilDeliveryNoteRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.odnNumber !== "") {
      obj.odnNumber = message.odnNumber;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOilDeliveryNoteRequest>, I>>(base?: I): GetOilDeliveryNoteRequest {
    return GetOilDeliveryNoteRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOilDeliveryNoteRequest>, I>>(object: I): GetOilDeliveryNoteRequest {
    const message = createBaseGetOilDeliveryNoteRequest();
    message.vesselImo = object.vesselImo ?? "";
    message.odnNumber = object.odnNumber ?? "";
    message.product = object.product ?? "";
    message.timestamp = object.timestamp ?? undefined;
    return message;
  },
};

function createBaseOilDeliveryNoteResponse(): OilDeliveryNoteResponse {
  return { data: undefined, version: 0 };
}

export const OilDeliveryNoteResponse: MessageFns<OilDeliveryNoteResponse> = {
  encode(message: OilDeliveryNoteResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      OilDeliveryNote.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(16).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OilDeliveryNoteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOilDeliveryNoteResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = OilDeliveryNote.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OilDeliveryNoteResponse {
    return {
      data: isSet(object.data) ? OilDeliveryNote.fromJSON(object.data) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: OilDeliveryNoteResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = OilDeliveryNote.toJSON(message.data);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OilDeliveryNoteResponse>, I>>(base?: I): OilDeliveryNoteResponse {
    return OilDeliveryNoteResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OilDeliveryNoteResponse>, I>>(object: I): OilDeliveryNoteResponse {
    const message = createBaseOilDeliveryNoteResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? OilDeliveryNote.fromPartial(object.data)
      : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseUpdateOilDeliveryNoteRequest(): UpdateOilDeliveryNoteRequest {
  return { data: undefined, expectedVersion: 0 };
}

export const UpdateOilDeliveryNoteRequest: MessageFns<UpdateOilDeliveryNoteRequest> = {
  encode(message: UpdateOilDeliveryNoteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      OilDeliveryNote.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(16).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateOilDeliveryNoteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateOilDeliveryNoteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = OilDeliveryNote.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateOilDeliveryNoteRequest {
    return {
      data: isSet(object.data) ? OilDeliveryNote.fromJSON(object.data) : undefined,
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: UpdateOilDeliveryNoteRequest): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = OilDeliveryNote.toJSON(message.data);
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateOilDeliveryNoteRequest>, I>>(base?: I): UpdateOilDeliveryNoteRequest {
    return UpdateOilDeliveryNoteRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateOilDeliveryNoteRequest>, I>>(object: I): UpdateOilDeliveryNoteRequest {
    const message = createBaseUpdateOilDeliveryNoteRequest();
    message.data = (object.data !== undefined && object.data !== null)
      ? OilDeliveryNote.fromPartial(object.data)
      : undefined;
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

export interface OilService {
  getOneOilDeliveryNote(
    request: DeepPartial<GetOilDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<OilDeliveryNoteResponse>;
  addOilDeliveryNote(request: DeepPartial<OilDeliveryNote>, metadata?: grpc.Metadata): Promise<OilDeliveryNoteResponse>;
  updateOilDeliveryNote(
    request: DeepPartial<UpdateOilDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<OilDeliveryNoteResponse>;
  getAllOilDeliveryNotes(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOilDeliveryNotesResponse>;
  getOilDeliveryNotes(
    request: DeepPartial<GetOilDeliveryNotesRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOilDeliveryNotesResponse>;
}

export class OilServiceClientImpl implements OilService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.getOneOilDeliveryNote = this.getOneOilDeliveryNote.bind(this);
    this.addOilDeliveryNote = this.addOilDeliveryNote.bind(this);
    this.updateOilDeliveryNote = this.updateOilDeliveryNote.bind(this);
    this.getAllOilDeliveryNotes = this.getAllOilDeliveryNotes.bind(this);
    this.getOilDeliveryNotes = this.getOilDeliveryNotes.bind(this);
  }

  getOneOilDeliveryNote(
    request: DeepPartial<GetOilDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<OilDeliveryNoteResponse> {
    return this.rpc.unary(
      OilServiceGetOneOilDeliveryNoteDesc,
      GetOilDeliveryNoteRequest.fromPartial(request),
      metadata,
    );
  }

  addOilDeliveryNote(
    request: DeepPartial<OilDeliveryNote>,
    metadata?: grpc.Metadata,
  ): Promise<OilDeliveryNoteResponse> {
    return this.rpc.unary(OilServiceAddOilDeliveryNoteDesc, OilDeliveryNote.fromPartial(request), metadata);
  }

  updateOilDeliveryNote(
    request: DeepPartial<UpdateOilDeliveryNoteRequest>,
    metadata?: grpc.Metadata,
  ): Promise<OilDeliveryNoteResponse> {
    return this.rpc.unary(
      OilServiceUpdateOilDeliveryNoteDesc,
      UpdateOilDeliveryNoteRequest.fromPartial(request),
      metadata,
    );
  }

  getAllOilDeliveryNotes(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOilDeliveryNotesResponse> {
    return this.rpc.unary(OilServiceGetAllOilDeliveryNotesDesc, EmptyRequest.fromPartial(request), metadata);
  }

  getOilDeliveryNotes(
    request: DeepPartial<GetOilDeliveryNotesRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetOilDeliveryNotesResponse> {
    return this.rpc.unary(OilServiceGetOilDeliveryNotesDesc, GetOilDeliveryNotesRequest.fromPartial(request), metadata);
  }
}

export const OilServiceDesc = { serviceName: "services.transportation.reports.OilService" };

export const OilServiceGetOneOilDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "GetOneOilDeliveryNote",
  service: OilServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetOilDeliveryNoteRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = OilDeliveryNoteResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const OilServiceAddOilDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "AddOilDeliveryNote",
  service: OilServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OilDeliveryNote.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = OilDeliveryNoteResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const OilServiceUpdateOilDeliveryNoteDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateOilDeliveryNote",
  service: OilServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateOilDeliveryNoteRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = OilDeliveryNoteResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const OilServiceGetAllOilDeliveryNotesDesc: UnaryMethodDefinitionish = {
  methodName: "GetAllOilDeliveryNotes",
  service: OilServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOilDeliveryNotesResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const OilServiceGetOilDeliveryNotesDesc: UnaryMethodDefinitionish = {
  methodName: "GetOilDeliveryNotes",
  service: OilServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetOilDeliveryNotesRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetOilDeliveryNotesResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
